<template>
    <div>
        <el-form :inline="true">
            <!-- <el-form-item label="创建时间：" label-width="100">
                <el-date-picker
                        v-model="searchForm.createTime"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy年MM月dd日"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button @click="getSysMemberCoupon" type="success">搜索</el-button>
            </el-form-item> -->
        </el-form>

        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                border
                stripe
                @selection-change="handleSelectionChange">


            <el-table-column
                label="优惠金额"
                align="center"
                prop="money"
                width="340">
            </el-table-column>
            <el-table-column
                    prop="sequence"
                    align="center"
                    label="发放顺序"
                    width="220">
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.sequence === 1" type="info">首次</el-tag>
                    <el-tag size="small" v-else-if="scope.row.sequence === 2" type="success">第二次</el-tag>
                    <el-tag size="small" v-else-if="scope.row.sequence === 3" type="success">剩余</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    label="发放数量"
                    align="center"
                    prop="number"
                    width="350">
            </el-table-column>
            <el-table-column
                    prop="icon"
                    align="center"
                    width="560"
                    fixed="right"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" plain @click="UpdateSysMemberCouponButton(scope.row.id)" v-if="hasAuth('sys:sysMemberCoupon:update')">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[10, 20, 50, 100]"
                :current-page="current"
                :page-size="size"
                :total="total">
        </el-pagination>
        <UpdateSysMemberCoupon ref="UpdateSysMemberCoupon" v-if="UpdateSysMemberCouponvisible" @refreshDataList="getSysMemberCoupon"></UpdateSysMemberCoupon>
    </div>
</template>

<script>
    import UpdateSysMemberCoupon from "./UpdateSysMemberCoupon";
    export default {
        name: "SysMemberCoupon",
        components:{
            UpdateSysMemberCoupon
        },
        data(){
            return{
                searchForm:{},
                delBtlStatu:true,
                tableData:[],
                multipleSelection:[],
                total: 0,
                size: 10,
                current: 1,
                UpdateSysMemberCouponvisible: false,
            }
        },
        created() {
            this.getSysMemberCoupon();
        },
        methods:{
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.delBtlStatu = val.length == 0
            },

            handleSizeChange(val) {
                this.size = val
                this.getSysMemberCoupon()
            },
            handleCurrentChange(val) {
                this.current = val
                this.getSysMemberCoupon()
            },
            //获取常量数据配置列表
            getSysMemberCoupon() {
                this.searchForm.pageNo=this.current
                this.searchForm.pageSize=this.size
                this.$axios.post("/admin/sysMemberCoupon/getSysMemberCoupon", this.searchForm).then(res => {
                    this.tableData = res.data.records
                    this.size = res.data.size
                    this.current = res.data.pages
                    this.total = res.data.total
                })
            },
            UpdateSysMemberCouponButton(id){
                this.UpdateSysMemberCouponvisible=true;
                this.$nextTick(()=>{
                    this.$refs.UpdateSysMemberCoupon.init(id);
                })
            },
        }
    }
</script>

<style scoped>
    .el-button{
        padding: 0 10px;
        height: 35px;
        line-height:35px;
        font-size:15px;
        margin-right: 10px;
    }
</style>
